import React from 'react'

export default function PagingEmpty({ count, children }) {
    return (
        <div className='border rounded-lg'>
            <div className='h-12 w-full bg-gray-50 rounded-t-lg'>
                <h1 className='p-3 text-sm text-gray-700'>Showing <span className='font-bold'>{count}</span> Entries.</h1>
            </div>
            {children}
            <div className='h-12 w-full bg-gray-50 rounded-b-lg'>
                <h1 className='p-3 text-sm text-gray-700'>Showing <span className='font-bold'>{count}</span> Entries.</h1>
            </div>
        </div>
    )
}
